import client from "./client";
import type { PaginatedResponse } from "@/types/common";
import type { ApprovalRequest, ApprovalStatus } from "@/types/approval";

export async function getApprovalQueue(
  page = 1,
  perPage = 20,
  status?: ApprovalStatus
): Promise<PaginatedResponse<ApprovalRequest>> {
  const params: Record<string, string> = {
    page: String(page),
    per_page: String(perPage),
  };
  if (status) params.status = status;
  const res = await client.get<PaginatedResponse<ApprovalRequest>>(
    "/approvals/queue",
    { params }
  );
  return res.data;
}

export async function getAllApprovals(
  page = 1,
  perPage = 50,
  status?: ApprovalStatus
): Promise<PaginatedResponse<ApprovalRequest>> {
  const params: Record<string, string> = {
    page: String(page),
    per_page: String(perPage),
  };
  if (status) params.status = status;
  const res = await client.get<PaginatedResponse<ApprovalRequest>>(
    "/approvals/all",
    { params }
  );
  return res.data;
}

export async function resolveApproval(
  id: string,
  status: ApprovalStatus,
  notes?: string
): Promise<void> {
  await client.put(`/approvals/${id}`, {
    status,
    reviewer_notes: notes,
  });
}

export async function bulkResolve(
  ids: string[],
  status: ApprovalStatus,
  notes?: string
): Promise<void> {
  await client.post("/approvals/bulk", { ids, status, reviewer_notes: notes });
}

export async function delegateApprovals(toUserId: string): Promise<void> {
  await client.post("/approvals/delegate", {
    delegate_to_user_id: toUserId,
  });
}
